<template>
  <div class="general-script-main">
    <h3>
      <span>{{$t('message.script_data_import') | title}}</span>
      <span class="wiki-link">
        <a :href="$t('message.script_data_import_export_doc_link')" target="_blank">
          WIKI
        </a>
      </span>
    </h3>

    <div v-if="willRunOnEachClusterNode == true" class="cluster-info">
      {{ $t('message.will_run_on_each_cluster_node') | title }}
    </div>
    <div v-if="willRunOnThisClusterNodeOnly == true" class="cluster-info">
      {{ $t('message.will_run_on_this_cluster_node_only') | title }}
    </div>

    <b-form v-if="importConfig">
      <b-form-row>
        <div class="col-3">
          <span class="label label-default">{{$t('message.data_import_export_import_source') | title}}</span>
        </div>
        <div class="col-4">
          <b-form-select v-model="importConfig.export_destination.type" :options="exportDestinationOptions"
            class="form-control" @change="onExportDestinationTypeChange" @input="isDirty=true"/>
        </div>
      </b-form-row>


      <b-form-row v-if="importConfig.export_destination.type == 'scp'">
        <div class="col-3">
          <span class="label label-default">
            {{$t('message.data_import_export_export_destination_scp_server') | title}}
          </span>
        </div>
        <div class="col-4">
          <b-form-input v-model="importConfig.export_destination.scp_server" @input="isDirty=true"/>
        </div>
      </b-form-row>

      <b-form-row v-if="importConfig.export_destination.type == 'scp'">
        <div class="col-3">
          <span class="label label-default">
            {{$t('message.data_import_export_export_destination_scp_server_port') | title}}
          </span>
        </div>
        <div class="col-4">
          <b-form-input v-model="importConfig.export_destination.scp_server_port" @input="isDirty=true"/>
        </div>
      </b-form-row>

      <b-form-row v-if="importConfig.export_destination.type == 'scp'">
        <div class="col-3">
          <span class="label label-default">
            {{$t('message.data_import_export_export_destination_scp_directory_path') | title}}
          </span>
        </div>
        <div class="col-4">
          <b-form-input v-model="importConfig.export_destination.scp_directory_path" @input="isDirty=true"/>
        </div>
      </b-form-row>

      <b-form-row v-if="importConfig.export_destination.type == 'scp'">
        <div class="col-3">
          <span class="label label-default">
            {{$t('message.data_import_export_export_destination_scp_username') | title}}
          </span>
        </div>
        <div class="col-4">
          <b-form-input v-model="importConfig.export_destination.scp_username" @input="isDirty=true"/>
        </div>
      </b-form-row>

      <b-form-row v-if="importConfig.export_destination.type == 'scp'">
        <div class="col-3">
          <span class="label label-default">
            {{$t('message.data_import_export_export_destination_scp_auth_method') | title}}
          </span>
        </div>
        <div class="col-4">
          <b-form-select v-model="importConfig.export_destination.scp_auth_method "
          :options="scpAuthTypeOptions" @input="isDirty=true"/>
        </div>
      </b-form-row>

      <b-form-row v-if="importConfig.export_destination.type == 'scp'  &&
                      importConfig.export_destination.scp_auth_method == 'password'">
        <div class="col-3">
          <span class="label label-default">
            {{$t('message.data_import_export_export_destination_scp_password') | title}}
          </span>
        </div>
        <div class="col-4">
          <b-form-input :type="scpPasswordInputType" v-model="importConfig.export_destination.scp_password"
             @input="isDirty=true" autocomplete="new-password"/>
        </div>
        <div class="col-2" v-if="importConfig.export_destination.scp_password && scpPasswordInputType  == 'password'">
          <svg class='icon icon-eye' @click="scpPasswordInputType='text'"/>
        </div>
        <div class="col-2" v-if="importConfig.export_destination.scp_password && scpPasswordInputType  == 'text'">
          <svg class='icon icon-eye-active' @click="scpPasswordInputType='password'"/>
        </div>
      </b-form-row>

      <b-form-row v-if="importConfig.export_destination.type == 'scp' &&
                        importConfig.export_destination.scp_auth_method == 'private key'">
        <div class="col-3">
          <span class="label label-default">
            {{$t('message.data_import_export_export_destination_scp_private_key') | title}}
          </span>
        </div>
        <div class="col-8">
          <b-form-textarea class="form-control" v-model="importConfig.export_destination.scp_private_key"
            rows="20" @input="isDirty=true"/>
        </div>
      </b-form-row>

      <b-form-row v-if="importConfig.export_destination.type == 'cifs'">
        <div class="col-3">
          <span class="label label-default">
            {{$t('message.data_import_export_export_destination_cifs_smb_server') | title}}
          </span>
        </div>
        <div class="col-4">
          <b-form-input v-model="importConfig.export_destination.cifs_smb_server" @input="isDirty=true"/>
        </div>
      </b-form-row>

      <b-form-row v-if="importConfig.export_destination.type == 'cifs'">
        <div class="col-3">
          <span class="label label-default">
            {{$t('message.data_import_export_export_destination_cifs_smb_share') | title}}
          </span>
        </div>
        <div class="col-4">
          <b-form-input v-model="importConfig.export_destination.cifs_smb_share" @input="isDirty=true"/>
        </div>
      </b-form-row>

      <b-form-row v-if="importConfig.export_destination.type == 'cifs'">
        <div class="col-3">
          <span class="label label-default">
            {{$t('message.data_import_export_export_destination_cifs_username') | title}}
          </span>
        </div>
        <div class="col-4">
          <b-form-input v-model="importConfig.export_destination.cifs_username" @input="isDirty=true"/>
        </div>
      </b-form-row>

      <b-form-row v-if="importConfig.export_destination.type == 'cifs'">
        <div class="col-3">
          <span class="label label-default">
            {{$t('message.data_import_export_export_destination_cifs_password') | title}}
          </span>
        </div>
        <div class="col-4">
          <b-form-input :type="cifsPasswordInputType" v-model="importConfig.export_destination.cifs_password"
            @input="isDirty=true"/>
        </div>
        <div class="col-2" v-if="importConfig.export_destination.cifs_password && cifsPasswordInputType == 'password'">
          <svg class='icon icon-eye' @click="cifsPasswordInputType='text'"/>
        </div>
        <div class="col-2" v-if="importConfig.export_destination.cifs_password && cifsPasswordInputType == 'text'">
          <svg class='icon icon-eye-active' @click="cifsPasswordInputType='password'"/>
        </div>
      </b-form-row>

      <b-form-row v-if="importConfig.export_destination.type == 'cifs'">
        <div class="col-3">
          <span class="label label-default">
            {{$t('message.data_import_export_export_destination_cifs_domain') | title}}
          </span>
        </div>
        <div class="col-4">
          <b-form-input v-model="importConfig.export_destination.cifs_domain" @input="isDirty=true"/>
        </div>
      </b-form-row>

      <div v-if="formError" class="form-error">{{formError}}</div>

      <b-button v-if="importConfig" variant="primary" type="button"
        class="padmin-button submit-button right" @click="showImportModal" :disabled="runInProgess">
        <b-spinner v-if="importInProgress" small type="grow"/>
        <span v-if="importDestinationSet">{{$t('message.button_import') | title}}</span>
        <span v-else>{{$t('message.button_restore') | title}}</span>
      </b-button>

      <b-button v-if="importConfig" variant="primary" type="button"
        class="padmin-button submit-button right" @click="showUploadModal" :disabled="runInProgess">
        <b-spinner v-if="uploadInProgress" small type="grow"/>
        {{$t('message.button_upload') | title}}
      </b-button>

    </b-form>

    <ConsoleOutput v-if="result != null" :result="result" :output="output"/>

    <b-modal ref="upload-import-modal" class="padmin-modal" id="import-data-modal-id" size="lg"
      :title="$t('message.data_import_export_import_params') | title" hide-footer no-close-on-backdrop>
      <b-form-row>
        <label class="label label-default col-4">
          {{ $t('message.data_import_export_import_param_db_file') }}
        </label>
        <b-form-file v-if="uploadOrImport=='upload'" v-model="uploadImportParams.db_dump_filename"
          :placeholder="$t('message.file_upload_placeholder')"
          :browse-text="$t('message.file_upload_browse_button')" accept=".enc"/>
        <b-form-select v-if="uploadOrImport=='import'"
          v-model="uploadImportParams.db_dump_filename" :options="importFilenameOptions" class="col-6"/>
      </b-form-row>

      <b-form-row>
        <label class="label label-default col-4">
          {{ $t('message.data_import_export_import_param_sm_control_file') }}
        </label>
        <b-form-file v-if="uploadOrImport=='upload'" v-model="uploadImportParams.sm_control_filename"
          :placeholder="$t('message.file_upload_placeholder')"
          :browse-text="$t('message.file_upload_browse_button')" accept=".enc"/>
        <b-form-select v-if="uploadOrImport=='import'"
          v-model="uploadImportParams.sm_control_filename" :options="importFilenameOptions" class="col-6"/>
      </b-form-row>

      <b-form-row>
        <label class="label label-default col-4">
          {{ $t('message.data_import_export_import_param_sm_data_file') }}
        </label>
        <b-form-file v-if="uploadOrImport=='upload'" v-model="uploadImportParams.sm_data_filename"
          :placeholder="$t('message.file_upload_placeholder')"
          :browse-text="$t('message.file_upload_browse_button')" accept=".enc"/>
        <b-form-select v-if="uploadOrImport=='import'"
          v-model="uploadImportParams.sm_data_filename" :options="importFilenameOptions" class="col-6"/>
      </b-form-row>

      <b-form-row>
        <label class="label label-default col-4">
          {{ $t('message.data_import_export_import_param_system_config_file') }}
        </label>
        <b-form-file v-if="uploadOrImport=='upload'" v-model="uploadImportParams.system_config_filename"
          :placeholder="$t('message.file_upload_placeholder')"
          :browse-text="$t('message.file_upload_browse_button')" accept=".enc"/>
        <b-form-select v-if="uploadOrImport=='import'"
          v-model="uploadImportParams.system_config_filename" :options="importFilenameOptions" class="col-6"/>
      </b-form-row>

      <b-form-row>
        <div class="col-4">
          <span class="label label-default">
            {{$t('message.data_import_export_decrypt_password') | title}} ({{$t('message.required')}})
          </span>
        </div>
        <div class="col-6">
          <b-form-input v-model="uploadImportParams.decrypt_password" :type="encryptPasswordInputType"
            @input="isDirty=true"/>
        </div>
        <div class="col-2" v-if="encryptPasswordInputType == 'password'">
          <svg class='icon icon-eye' @click="encryptPasswordInputType='text'"/>
        </div>
        <div class="col-2" v-if="encryptPasswordInputType == 'text'">
          <svg class='icon icon-eye-active' @click="encryptPasswordInputType='password'"/>
        </div>
      </b-form-row>

      <b-modal-footer>
        <b-button variant="secondary" @click="$refs['upload-import-modal'].hide()">
          {{$t('message.button_close') | title}}
        </b-button>
        <b-button v-if="uploadOrImport=='import'" :disabled="runInProgress" variant="danger" @click="importData()">
          <b-spinner v-if="importInProgress" small type="grow"/>
          <span v-if="importDestinationSet">{{$t('message.button_import') | title}}</span>
          <span v-else>{{$t('message.button_restore') | title}}</span>
        </b-button>
        <b-button v-if="uploadOrImport=='upload'" :disabled="runInProgress" variant="danger" @click="uploadData()">
          <b-spinner v-if="uploadInProgress" small type="grow"/>
          {{$t('message.button_upload') | title}}
        </b-button>
      </b-modal-footer>
    </b-modal>

  </div>
</template>

<script>
import { get, post } from "../http"
import ConsoleOutput from "./ConsoleOutput"
import {validateHostName, validateUsername, validateTime, validatePort, validateDirectoryPath, validatePassword} from "../util"

export default {
  name: "importConfig",

  components: {
    ConsoleOutput
  },

  data() {
    return {
      exportDestinationOptions:[{value: '', text: this.$t('message.data_import_export_export_destination_none')},
                                {value: 'scp', text: this.$t('message.data_import_export_export_destination_scp')},
                                {value: 'cifs', text: this.$t('message.data_import_export_export_destination_cifs')}],
      importConfig: null,
      result: null,
      output: "",
      formError: '',
      importInProgress: false,
      uploadInProgress: false,
      encryptPasswordInputType: 'password',
      scpPasswordInputType: 'password',
      cifsPasswordInputType: 'password',
      uploadImportParams: {'db_dump_filename': null, 'sm_control_filename': null, 'sm_data_filename': null,
        'system_config_filename': null, 'encrypt_password': null},
      importFilenameOptions: [],
      uploadOrImport: null,
      isDirty: false,
      scpAuthTypeOptions: [{value: 'password', text: this.$t('message.data_import_export_export_destination_scp_password')},
                           {value: 'private key', text: this.$t('message.data_import_export_export_destination_scp_private_key')}]
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    runInProgress() {
      return this.saveInProgress || this.importInProgress
    },

    importButtonDisabled() {
      return this.runInProgess
    },

    downloadButtonDisabled() {
      return this.runInProgess
    },

    importDestinationSet() {
      return this.importConfig && this.importConfig.export_destination &&
        this.importConfig.export_destination.type != '' && this.importConfig.export_destination.type != 'none'
    }
  },

  methods: {
    getUrl() {
      return ('/scripts/data/import')
    },

    load() {
      get(this.getUrl()).then(
        resp => {
          this.importConfig = resp.data.params.auto_backup.value
          if (this.importConfig) {
            if (!this.importConfig.daily_at_time && this.importConfig.daily_at_hour) {
              this.importConfig.daily_at_time = this.importConfig.daily_at_hour + ':00'
            }
            if (!this.importConfig.keep_for_days) {
              this.importConfig.keep_for_days = '30'
            }
            if (!this.importConfig.export_sm_data) {
              this.importConfig.export_sm_data = false
            }

            if (this.importConfig.auto_enabled  == undefined) {
              this.importConfig.auto_enabled = this.importConfig.enabled
            }

            if (this.importConfig.export_destination) {
              if (this.importConfig.export_destination.scp_auth_method == undefined) {
                this.$set(this.importConfig.export_destination, 'scp_auth_method', 'password')
              }
            } else {
              this.importConfig.export_destination = {
                  'type': '',
                  'scp_server': '',
                  'scp_username': '',
                  'scp_auth_method': 'password',
                  'scp_password': '',
                  'scp_private_key': '',
                  'scp_directory_path': ''
              }
            }

          } else {
            this.importConfig = {
              'enabled': false,
              'daily_at_hour': 4,
              'encrypt_password': '',
              'export_sm_data': false,
              'export_destination': {
                  'type': '',
                  'scp_server': '',
                  'scp_username': '',
                  'scp_auth_method': 'password',
                  'scp_password': '',
                  'scp_private_key': '',
                  'scp_directory_path': ''
              }
            }
          }
        },
        err => {
          console.log('err', err)
        })
    },

    showImportModal() {
      this.uploadOrImport = 'import'
      this.uploadImportParams = {}
      this.importInProgress = true
      this.loadImportFilenames()
    },

    showUploadModal() {
      this.uploadOrImport = 'upload'
      this.uploadImportParams = {}
      this.$refs['upload-import-modal'].show()
    },

    loadImportFilenames() {
      this.formError = ''
      this.result = null
      this.importInProgress = true

      post('/list_import_filenames', this.importConfig['export_destination']).then(
        resp => {
          this.importInProgress = false
          if (resp.data.result) {
            this.importFilenameOptions = resp.data.filenames
            this.$refs['upload-import-modal'].show()
          } else {
            this.result = resp.data.result
            if (resp.data.error) {
              this.formError = resp.data.error
            }
          }
        },
        err => {
          console.log('err', err)
          this.importInProgress = false
        }
      )
    },

    importData() {
      if (!this.uploadImportParams.decrypt_password) {
        this.formError = this.$t('message.error_missing') + ': ' + this.$t('message.data_import_export_decrypt_password')
        this.$refs['upload-import-modal'].hide()
        return
      }

      this.importInProgress = true
      this.result = null
      this.output = ''
      this.formError = ''

      let data = {params: this.uploadImportParams, source: this.importConfig['export_destination']}

      post('/import_data', data).then(
        resp => {
          this.result = resp.data.result
          this.output = resp.data.output
          this.formError = resp.data.error
          this.importInProgress = false
          this.$refs['upload-import-modal'].hide()
          if (this.uploadImportParams.db_dump_filename) {
            this.$root.$emit("bv::show::modal", "passman-restart-modal-id")
          }
          if(this.uploadImportParams.system_config_filename) {
            this.$root.$emit("bv::show::modal", "padmin-restart-modal-id")
          }
        },
        err => {
          console.log('err', err);
          this.importInProgress = false
          this.result = false
          this.output = err
          this.$refs['upload-import-modal'].hide()
        }
      )
    },

    uploadData() {
      if (!this.uploadImportParams.decrypt_password) {
        this.formError = this.$t('message.error_missing') + ': ' + this.$t('message.data_import_export_decrypt_password')
        this.$refs['upload-import-modal'].hide()
        return
      }

      this.uploadInProgress = true
      this.result = null
      this.output = ''
      this.formError = ''

      const formData = new FormData()
      for (const [key, value] of Object.entries(this.uploadImportParams)) {
        if (value) {
          formData.append(key, value)
        }
      }

      post('/upload_data', formData, {"content-type": "multipart/form-data"}, this.uploadImportParams).then(
        resp => {
          this.result = resp.data.result
          this.output = resp.data.output
          this.formError = resp.data.error
          this.uploadInProgress = false
          this.$refs['upload-import-modal'].hide()
          if (this.uploadImportParams.db_dump_filename) {
            this.$root.$emit("bv::show::modal", "passman-restart-modal-id")
          }
          if(this.uploadImportParams.system_config_filename) {
            this.$root.$emit("bv::show::modal", "padmin-restart-modal-id")
          }
        },
        err => {
          console.log('err', err);
          this.importInProgress = false
          this.result = false
          this.output = err
          this.$refs['upload-import-modal'].hide()
        }
      )
    }
  }
}
</script>
